import React from 'react';
import PropTypes from 'prop-types';
import styles from './BillingInformation.module.less';

const billingInformation = (props) => {
  const { address, city, state } = props.data;
  const postalCode = props.data.postal_code;
  const countryCode = props.data.country_code;
  const billingAddress = `${address}, ${city}, ${state}, ${postalCode} -  ${countryCode}`;

  return (
    <div className={styles.container}>
      <div className={styles.summaryLine}>
        {gettext('You are set to')} <strong>{gettext('Credit Card')} </strong>
        {gettext('Payment')}
      </div>
      <div className={styles.summaryLine}>
        {gettext('Card Number')} <strong>{props.data.number}</strong>
      </div>
      <div className={styles.summaryLine}>{billingAddress}</div>
    </div>
  );
};

billingInformation.propTypes = {
  data: PropTypes.object,
};

export default billingInformation;
